import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
// import { withRouter } from 'react-router';
import {Input, Label, Button, Collapse, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

import VendorsTable from '../../Components/VendorsTable/VendorsTable';
import Logic from '../../Logic';

class Vendors extends Component {
    constructor(props) {
        super(props);
        this.state = 
        {
            modalOpended:false,
            id: -1,
            code: null,
            name: null
        };
        // this.onFormSubmitted = this.onFormSubmitted.bind(this);
        this.toggle = this.toggle.bind(this);
        this.clear = this.clear.bind(this);
        this.save = this.save.bind(this);
        this.onVendorUpdate = this.onVendorUpdate.bind(this);
        this.onVendorDelete = this.onVendorDelete.bind(this);
    }
    
    componentDidMount(){
        let logic = new Logic();
        logic.getAllVendors((data) =>{
            this.setState({vendors:data});
        });
    }

    toggle(){
        this.setState(prevState => ({modalOpended:!prevState.modalOpended}));
    }

    onVendorUpdate(vendor){
        this.setState(prevState => ({
            modalOpended:true,
            id : vendor.id,
            code: vendor.code,
            name: vendor.name
        }));
    }

    onVendorDelete(vendor){
        if(window.confirm('האם אתה בטוח שברצונך למחוק את הספק?')){
            alert('TODO');
        }
    }

    updateFormField(field, value){
        let prev = this.state;
        prev[field] = value;
        this.setState({...prev});
    }

    save(){
        let logic = new Logic();
        logic.saveVendor(this.state.id, this.state.code, this.state.name, (res) => {
            alert(res.message);
            if(res.success){
                this.setState({vendors:res.data});
                this.toggle();
                this.clear();
            }else{
                alert('אירעה שגיאה!');
            }
        });
    }

    clear(){
        this.setState( 
        {
            id : -1,
            code: null,
            name: null
        });
    }

    render(){
        return (
            <div>
                {this.props.init ?
                <>
                    <Button color="danger" style={{marginBottom:'10px'}} onClick={this.toggle}><FontAwesome name="plus"/> צור ספק חדש</Button>
                    <Modal isOpen={this.state.modalOpended} toggle={this.toggle}>
                        <ModalHeader toggle={this.toggle}>יצירת ספק חדש</ModalHeader>
                        <ModalBody>
                            <div>
                                <Label>קוד ספק</Label>
                                <Input type="text" className="col-xs-4" value={this.state.code || ''} onChange={evt => this.updateFormField('code', evt.target.value)}/>
                            </div>

                            <div>
                                <Label>שם ספק</Label>
                                <Input type="text" className="col-xs-4" value={this.state.name || ''} onChange={evt => this.updateFormField('name', evt.target.value)}/>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.save}><FontAwesome name="check"/> שמור</Button>
                            <Button color="secondary" onClick={this.clear} style={{marginRight:'20px'}}><FontAwesome name="times"/> נקה</Button>
                        </ModalFooter>
                    </Modal>
                    {this.state.vendors ? <VendorsTable init={this.props.init} vendors={this.state.vendors} onVendorUpdate={this.onVendorUpdate} onVendorDelete={this.onVendorDelete}/> : null}
                </> : null}
            </div>
        );
    }
  };
  
export default Vendors;